import { useCallback, useMemo, useRef } from 'react';

export default function useInterval(fn, interval) {
  const intervalRef = useRef(null);

  const startInterval = useCallback(() => {
    intervalRef.current = setInterval(fn, interval);
  }, [fn]);

  const pauseInterval = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  }, []);

  return useMemo(() => ({ startInterval, pauseInterval }), [startInterval, pauseInterval]);
}
